// plugins
import Choices from '../../../../assets/vendor/choices.js/public/assets/scripts/choices.js';
import GLightbox from '../../../../assets/vendor/glightbox/glightbox.min.js';
import Cookies from '../../../../assets/vendor/js-cookie/dist/js.cookie.mjs';
 
// local
import Header from './partials/header';
import Animate from './partials/animate';
import Form from './partials/form';
import AjaxData from './partials/ajax-data';
import Logout from './partials/logout';
import {LikeToggle, LikeLabel} from './partials/like-toggle';
import StickyElement from './partials/sticky-element';
import PoiView from './components/poi-view';
import Modal from './partials/modals';
import './components/advent-canvas';
import './partials/lazy-load-observer';
import FormWithAccountDefaults from "./components/form-with-account-defaults";

window.initDom = ($wrapper) => {
    $wrapper.querySelectorAll('[data-button-slider]').forEach( async($slider) => {
        const ButtonSlider = await import('./partials/button-slider');
        (new ButtonSlider.default($slider).init());
    });
    $wrapper.querySelectorAll('[data-date-slider]').forEach( async($slider) => {
        const DateSlider = await import('./partials/date-slider');
        (new DateSlider.default($slider).init());
    });
    $wrapper.querySelectorAll('[data-collapsible]').forEach( async($collapsible) => {
        const Collapsible = await import('./partials/collapsible');
        (new Collapsible.default($collapsible));
    });
    $wrapper.querySelectorAll('[data-number]').forEach( async($number) => {
        const Number = await import('./partials/number');
        (new Number.default($number));
    });
    $wrapper.querySelectorAll('[data-modal]').forEach( async($modal) => {
        (new Modal($modal));
    });
    $wrapper.querySelectorAll('a[href^="#"]').forEach(async(link) => {
        const ScrollTo = await import('./partials/scroll-to');
        (new ScrollTo.default(link));
    });
    $wrapper.querySelectorAll('[data-animate]').forEach($el => (new Animate($el)));
    $wrapper.querySelectorAll('[data-theme-switcher]').forEach(async($el) => {
        const ThemeSwitcher = await import('./partials/theme-switcher');
        (new ThemeSwitcher.default($el));
    });
    $wrapper.querySelectorAll('[data-recipe-content]').forEach(async($el) => {
        const RecipeContent = await import('./components/recipe-content');
        (new RecipeContent.default($el));
    });
    $wrapper.querySelectorAll('[data-recipe-clipboard]').forEach(async($el) => {
        const RecipeClipboard = await import('./components/recipe-clipboard');
        (new RecipeClipboard.default($el));
    });
    $wrapper.querySelectorAll('[data-block-type="recipe-video"],[data-block-type="recipe-cooking-view"]').forEach(async($el) => {
        const RecipeVideo = await import('./components/recipe-video');
        (new RecipeVideo.default($el));
    });
    $wrapper.querySelectorAll('[data-block-type="recipe-content"],[data-block-type="recipe-cooking-view"]').forEach(async($el) => {
        const IngredientCalculator = await import('./partials/ingredient-calculator');
        (new IngredientCalculator.default($el));
    });
    $wrapper.querySelectorAll('form').forEach($el => (new Form($el)));
    $wrapper.querySelectorAll('[data-newsletter-form]').forEach( async($newsletter) => {
        const Newsletter = await import('./partials/newsletter');
        (new Newsletter.default($newsletter));
    });
    $wrapper.querySelectorAll('[data-logout]').forEach( $form => (new Logout($form)));
    $wrapper.querySelectorAll('[data-toggle-like]').forEach( $el => (new LikeToggle($el)));
    $wrapper.querySelectorAll('[data-like-label]').forEach( $el => (new LikeLabel($el)));
    $wrapper.querySelectorAll('[data-rating]').forEach( async($el) => {
        const Rating = await import('./partials/rating');
        (new Rating.default($el));
    });
    $wrapper.querySelectorAll('#form-9xJ42 form').forEach( async($el) => {
        const SearchSuggestionForm = await import('./components/search-suggestion');
        (new SearchSuggestionForm.default($el));
    });
    $wrapper.querySelectorAll('[data-floating-button]').forEach( async($el) => {
        const FloatingButton = await import('./partials/floating-button');
        (new FloatingButton.default($el));
    });
    $wrapper.querySelectorAll('[data-block-type="advent-day-detail"]').forEach(async($el) => {
        const AdventDayDetail = await import('./components/advent-day-detail');
        new AdventDayDetail.default($el);
    });
    $wrapper.querySelectorAll('[data-block-type="event-episode-list"]').forEach(async($el) => {
        const EventEpisodeList = await import('./components/event-episode-list');
        new EventEpisodeList.default($el);
    });
    $wrapper.querySelectorAll('[data-block-type="program-detail"]').forEach(async($el) => {
        const ProgramCta = await import('./components/program-cta');
        (new ProgramCta.default($el));
    });
    $wrapper.querySelectorAll('[data-block-type="tv-guide"]').forEach(async($el) => {
        const TVGuide = await import('./components/tv-guide');
        (new TVGuide.default($el));
    });
    $wrapper.querySelectorAll('[data-block-type="recipe-cooking-view"]').forEach(async($el) => {
        const CookingView = await import('./partials/cooking-view');
        (new CookingView.default($el));
    });
    // Don't load adds async as we want them to load as fast as possible
    $wrapper.querySelectorAll('[data-block-type="poi-detail"]').forEach($el => (new PoiView($el)));
    $wrapper.querySelectorAll('[data-href]').forEach(async($el) => {
        const LinkTo = await import('./partials/link-to');
        (new LinkTo.default($el));
    });
    $wrapper.querySelectorAll('[data-recipe-print]').forEach(async($el) => {
        const RecipePrint = await import('./partials/recipe-print');
        (new RecipePrint.default($el));
    });
    $wrapper.querySelectorAll('[data-recipe-notes]').forEach(async($el) => {
        const RecipeStepNotes = await import('./partials/recipe-step-notes');
        (new RecipeStepNotes.default($el));
    });
    // Collapsable is a variation on expandable that can be initiated in the wysiwyg
    $wrapper.querySelectorAll('.collapsable-trigger').forEach(async($el) => {
        const ReadingCollapsable = await import('./partials/reading-collapsable');
        new ReadingCollapsable.default($el);
    })
    $wrapper.querySelectorAll('.collapsable-trigger').forEach(async($el) => {
        const ReadingCollapsable = await import('./partials/reading-collapsable');
        new ReadingCollapsable.default($el);
    });

    $wrapper.querySelectorAll('[data-block-type="ebook-detail"]').forEach(async($el) => {
        const EbookDetail = await import('./components/ebook-detail');
        new EbookDetail.default($el);
    });

    $wrapper.querySelectorAll('[data-block-type="ebook-thank-you"]').forEach(async($el) => {
        const EbookThankYou = await import('./components/ebook-thank-you');
        new EbookThankYou.default($el);
    });

    $wrapper.querySelectorAll('[data-block-type="account-preferences-form"]').forEach(async($el) => {
        const AccountPreferencesForm = await import('./components/account-preferences-form');
        new AccountPreferencesForm.default($el);
    });

    $wrapper.querySelectorAll('[data-password]').forEach(async($el) => {
        const PasswordControl = await import('./partials/password-control');
        (new PasswordControl.default($el));
    });

    $wrapper.querySelectorAll('[data-block-type="account-collection-list"]').forEach(async($el) => {
        const AccountCollectionList = await import('./components/account-collection-list');
        (new AccountCollectionList.default($el));
    });

    $wrapper.querySelectorAll('[data-block-type="account-curated-menu-list"]').forEach(async($el) => {
        const AccountCuratedMenuList = await import('./components/account-curated-menu-list');
        (new AccountCuratedMenuList.default($el));
    });

    $wrapper.querySelectorAll('[data-account-add-recipe-to-curated-menu]').forEach(async($el) => {
        const AccountAddRecipeToCuratedMenu = await import('./components/account-add-recipe-to-curated-menu');
        (new AccountAddRecipeToCuratedMenu.default($el));
    });

    $wrapper.querySelectorAll('[data-block-type="account-collection-detail"]').forEach(async($el) => {
        const AccountCollectionDetail = await import('./components/account-collection-detail');
        (new AccountCollectionDetail.default($el));
    });

    $wrapper.querySelectorAll('[data-block-type="account-curated-menu-detail"]').forEach(async($el) => {
        const AccountCuratedMenuDetail = await import('./components/account-curated-menu-detail');
        (new AccountCuratedMenuDetail.default($el));
    });

    $wrapper.querySelectorAll('[data-block-type="contest-form"]').forEach(async($el) => {
        (new FormWithAccountDefaults($el));
    });

    $wrapper.querySelectorAll('[data-block-type="account-form"]').forEach(async($el) => {
        const AccountForm = await import('./components/account-form');
        (new AccountForm.default($el));
    });

    $wrapper.querySelectorAll('[data-filter-buttons]').forEach(async($el) => {
        const FilterButtons = await import('./partials/filter-buttons');
        (new FilterButtons.default($el));
    });


    $wrapper.querySelectorAll('[data-dropdown]').forEach($select => {
        (new Choices($select, {
                searchEnabled: $select.querySelectorAll('option').length > 8,
                itemSelectText: "",
                placeholder: true,
                shouldSort: false,
                removeItemButton: $select.getAttribute('multiple') !== null,
                classNames: {
                    containerOuter: ['choices', ...$select.classList]
                }
            }
        ));
    });

    $wrapper.querySelectorAll('[data-tooltip]').forEach(async($el) => {
        const tooltip = await import('./partials/tooltip');
        new tooltip.default($el);
    });

    $wrapper.querySelectorAll('[data-sticky-container]').forEach($element => new StickyElement($element));

    /**
     * Wrap videos in reading in video container
     */
    $wrapper.querySelectorAll('.reading iframe[src*="youtube.com"], .reading iframe[data-cmp-src*="youtube.com"]').forEach(($el) => {
        if (!$el.parentElement.classList.contains('.video-container')) {
            let wrapper = document.createElement('div');
            wrapper.classList.add('video-container')
            $el.parentNode.insertBefore(wrapper, $el);
            wrapper.appendChild($el);
        }
    });

    (new AjaxData($wrapper)).updateDom();
}


// Cross-browser event listener
function addEvent(el, evt, fn) {
    if (el.addEventListener) {
        el.addEventListener(evt, fn);
    } else if (el.attachEvent) {
        el.attachEvent('on' + evt, function (evt) {
            fn.call(el, evt);
        });
    } else if (typeof el['on' + evt] === 'undefined' || el['on' + evt] === null) {
        el['on' + evt] = function (evt) {
            fn.call(el, evt);
        };
    }
}

(function() {
    window.initDom(document);
    document.querySelectorAll('[data-header]').forEach( $header => (new Header($header)));

    // scroll to
    if(window.location.hash && !window.location.hash.startsWith("#search") && document.querySelector(window.location.hash)) {
        document.querySelector(window.location.hash).scrollIntoView({
            behavior: 'smooth'
        });
    }

    // add event listener for iframe events
    addEvent(window, 'message', function (message) {
        try {
            var data = JSON.parse(message.data);
            var dataLayer = window.dataLayer || (window.dataLayer = []);
            if (data.event) {
                dataLayer.push({
                    'event': data.event,
                    'postMessageData': data
                });
            }
        } catch (e) {
        }
    });

    const showModal = () => {
        setTimeout(async () => {
            const $modalOnLoad = document.querySelector('[data-modal][data-modal-onload]');
            const blockList = $modalOnLoad?.dataset.modalOnloadBlocklist
                    ? $modalOnLoad.dataset.modalOnloadBlocklist.split(',')
                    : [];
            const urlInBlockList = blockList.includes(window.location.href);

            if ($modalOnLoad && ! Cookies.get($modalOnLoad.dataset.modal) && ! urlInBlockList) {
                const Modal = await import('./partials/modals');
                Cookies.set($modalOnLoad.dataset.modal, 1, {expires: 1});
                (new Modal.default($modalOnLoad)).openModal();
            }
        }, 500) // we need to add a timeout otherwise the accept click closes the modal
    }
    __cmp("addEventListener",["consent",showModal,false],null);

    if(window.innerWidth >= 576) {
        GLightbox({
            selector: '[data-glightbox]',
            touchNavigation: true,
            loop: true,
            autoplayVideos: true
        });
    } else {
        document.querySelectorAll('[data-glightbox]').forEach($el => {
            $el.addEventListener('click', (e) => e.preventDefault())
        });
    }
})();
